// @flow

import {Tag} from 'docs/util';
import type {MarkdocTagRegistration} from 'docs/markdoc';
import {getMarkdocElementSchema} from '../getMarkdocElementSchema';

export const AttributeReference: MarkdocTagRegistration = {
  tag: 'markdoc-attribute-reference',
  component: 'MarkdocAttributeReference',
  attributes: {
    tag: {
      type: String,
      description:
        'The name of a markdoc tag as defined in the markdoc registration.',
    },
    node: {type: String},
  },
  render(node, config) {
    const tagName = (node.attributes.tag: any);
    const nodeName = (node.attributes.node: any);
    const tag = getMarkdocElementSchema(tagName || nodeName);

    return new Tag(this.tag, {tag});
  },
};
